// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import * as ui from '@digital/ui';

//Api
import {
    CrfCicloOrcamentarioRelatorio,
    CrfFiltros,
    postGetAllCrfRelatorioControleRfa
} from '@app/api/crf/crfRelatorioCicloOrcamentario';

//Files
import TableBuilUp from './TableBuilUp'

//Utils

const Buildup = () => {

    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();

    const handleFilter = () => {
        const filtros = {
            classificaoRfa: ["cfa9347a-ff40-4842-9b4c-4f19e5eba109"] //ID Status Aprovada
        } as CrfFiltros;
        postGetAllCrfRelatorioControleRfa(filtros).then((data) => {
            setCicloOrcamentarioRelatorioTotal(data);
        });
        return true;
    }

    useEffect(() => { handleFilter() }, [])
    return (
        <ui.SimpleView >
            <ui.GridView noform>
                <ui.Widget
                    title="Controle RFA"
                    span={12}
                    actions={[]}>
                    {cicloOrcamentarioRelatorioTotal ?
                        <TableBuilUp
                            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
                            paginacaoConfig={{ pageSize: 25 }}
                            relatorioControleRfa={true}
                        /> : <> </>}
                </ui.Widget>
            </ui.GridView>
        </ui.SimpleView>
    );
};

export default Buildup;
